import { hFetch } from '@/lib/hfetch';

type PipelineReviewAnswerListItem = {
  question_id: number;
  question: string;
  answer: string;
  field_type: 'rich_text';
};

export const listAnswers = async (pipelineReviewId: number) => {
  return await hFetch<PipelineReviewAnswerListItem[]>({
    url: `/api/pipeline_review/answers?pipeline_review_id=${pipelineReviewId}`,
  });
};
